import _classCallCheck from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { GenericPollOperation } from "./operation";
import { Poller } from "../poller";

function deserializeState(serializedState) {
  try {
    return JSON.parse(serializedState).state;
  } catch (e) {
    throw new Error("LroEngine: Unable to deserialize state: ".concat(serializedState));
  }
}
/**
 * The LRO Engine, a class that performs polling.
 */


export var LroEngine = /*#__PURE__*/function (_Poller) {
  _inherits(LroEngine, _Poller);

  function LroEngine(lro, options) {
    var _this;

    _classCallCheck(this, LroEngine);

    var _ref = options || {},
        _ref$intervalInMs = _ref.intervalInMs,
        intervalInMs = _ref$intervalInMs === void 0 ? 2000 : _ref$intervalInMs,
        resumeFrom = _ref.resumeFrom;

    var state = resumeFrom ? deserializeState(resumeFrom) : {};
    var operation = new GenericPollOperation(state, lro, options === null || options === void 0 ? void 0 : options.lroResourceLocationConfig, options === null || options === void 0 ? void 0 : options.processResult, options === null || options === void 0 ? void 0 : options.updateState, options === null || options === void 0 ? void 0 : options.isDone);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(LroEngine).call(this, operation));
    _this.config = {
      intervalInMs: intervalInMs
    };
    operation.setPollerConfig(_this.config);
    return _this;
  }
  /**
   * The method used by the poller to wait before attempting to update its operation.
   */


  _createClass(LroEngine, [{
    key: "delay",
    value: function delay() {
      var _this2 = this;

      return new Promise(function (resolve) {
        return setTimeout(function () {
          return resolve();
        }, _this2.config.intervalInMs);
      });
    }
  }]);

  return LroEngine;
}(Poller);